import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const echoConfig = {
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
    wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['wss', 'ws'],
    withCredentials: true,

    authEndpoint: '/broadcasting/auth',
    auth: {
        headers: {
            /**
             * Read per authorization attempt, not once at module evaluation.
             *
             * `/broadcasting/auth` is on the web group, so VerifyCsrfToken
             * applies. Freezing the token meant that after a login — which
             * regenerates the session and therefore the token — every channel
             * authorization replayed the dead one and 419'd. The socket stayed
             * up while every private channel silently failed to subscribe, so
             * the app stopped receiving invalidations and its caches drifted:
             * a staleness bug whose real cause was authentication.
             *
             * A getter rather than a value because pusher-js reads each header
             * off this object at request time. utils/csrf.js refreshes the meta,
             * so this always sees the newest token the tab has been given.
             */
            get 'X-CSRF-TOKEN'() {
                return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';
            },
            /**
             * Echo's connector *assigns* this header during setOptions, using the
             * token it read when the connector was constructed. A getter-only
             * property makes that assignment throw in strict mode and takes the
             * whole app down with it, so the setter has to exist — but it
             * deliberately discards the value, because the token Echo captured at
             * construction is exactly the stale one this getter exists to replace.
             */
            set 'X-CSRF-TOKEN'(_ignored) {},
        },
    },
};

let echo = new Echo(echoConfig);

let socketId = null;
echo.connector.pusher.connection.bind('connected', () => {
    socketId = echo.socketId();
});

window.Echo = echo;
export default echo;
